import Button from '@restart/ui/esm/Button';
import React, { useEffect, useState } from 'react';
import './HomeBody.css';
import { BsArrowRight, BsArrowRightShort } from "react-icons/bs";
import { Link, useHistory } from 'react-router-dom';
import { Card, CardGroup, Col, Container, Row } from 'react-bootstrap';

const HomeBody = (props) => {
    const { idLeague, strLeague, strLeagueAlternate, strSport } = props.league;
    let history = useHistory();

    function handleClick() {
        history.push(`/details/${idLeague}`);
    }

    const [league, setLeague] = useState([]);
    useEffect(() => {
        const url = `https://www.thesportsdb.com/api/v1/json/2/lookupleague.php?id=${idLeague}`;
        fetch(url)
            .then((response) => response.json())
            .then(data => {
                setLeague(data.leagues[0]);
                
            })
    }, [])

    // const shuffle = a => {
    //     for (let i = a.length; i; i--) {
    //         let j = Math.floor(Math.random() * i);
    //         [a[i - 1], a[j]] = [a[j], a[i - 1]];
    //     }
    // }

    // const randomData = shuffle(league);
    console.log(league);

    const { strBadge, strBanner, strLogo } = league;

    return (
        <div style={{ backgroundColor: 'red' }}>
            <div className="home-body mt-5 col-ml-4 col-sm-12 col-lg-4 col-md-4" style={{ float: 'left' }} >

                <Row className="g-4 mx-3">
                    {Array.from({ length: 1 }).map((_, idx) => (
                        <Col className="d-ds">
                            <Card className="col-md-12 py-4 single-card" >
                                <Card.Img variant="top" src={strBadge} style={{ width: '50%', margin: '0 auto' }} />
                                <Card.Body className="text-center">
                                    <Card.Title>
                                        <h5 class="card-title fw-bold">{strLeague}</h5>
                                    </Card.Title>
                                    <Card.Text>
                                        <p>Sports Type: {strSport}</p>
                                        <Button className="btn " onClick={handleClick} style={{ backgroundColor: '#3a42ff', borderRadius: '0', color: 'white', fontSize: '1rem' }}>Explore <BsArrowRight /></Button>
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>

                {/* <div class="row row-cols-1 row-cols-md-4 g-4" style={{}}>
    <div class="col">
        <div class="card">
            <img src="..." class="card-img-top" alt="..."/>
            <div class ="card-body">
            <h5 class ="card-title">Card title</h5>
            <p class ="card-text">This is a longer card with supporting text below as a natural lead-in to additional content.This content is a little bit longer.</p>
            </div>
        </div>
    </div>
</div> */}



                {/* <div class="row row-cols-1 row-cols-md-3 g-4"> */}
                {/* <div class="row">
    <div class="col-lg-4">
        <div class="card text-center d-flex justify-content-center">
            <img src={strBadge} class="card-img-top img-fluid " alt="..." style={{ width: '50%'}}/>
            <div class ="card-body">
            <h5 class ="card-title"><h5 className="fw-bold">{strLeague}</h5></h5>
            <p>Sports Type: {strSport}</p>
                <Button className="btn " onClick={handleClick} style={{ backgroundColor: '#3a42ff', borderRadius: '0', color: 'white', fontSize: '1rem' }}>Explore <BsArrowRight /></Button>
            </div>
        </div>
    </div>
</div> */}

                {/* <Container className=""> */}
                {/* <Row>
        <Col sm={8}>sm=8</Col>
        <Col sm={4}>sm=4</Col>
    </Row> */}

                {/* <h5 className="fw-bold">{strLeague}</h5> */}

                {/* </Container> */}


                {/* <h4>{strLeague}</h4>
        <h4>{strLeague}</h4>
        <p>Sports Type: {strSport}</p>
        <Button className="btn btn-primary" onClick={handleClick}>Explore <BsArrowRight /></Button> */}


            </div>
        </div>
    );
};

export default HomeBody;